<template>
    <CardContentPanel icon="creditcard" v-bind="{action, index}">
        <template #title>{{ $t('projectclient.projectview.activity.pending.actions.PAID_EXPENSE_REPORT.title') }}</template>
        <template #body>
            {{ $t('projectclient.projectview.activity.pending.actions.PAID_EXPENSE_REPORT.description') }}
        </template>
        <template #actions>
            <NuxtLink
                :to="`/project-payment/${action.extraData.expenseApprovalSetId}?origin=project-view`"
                external
                data-testid="pending-action-card-cta-primary"
            >
                <VJoyButton variant="main" size="small">
                    {{ $t('projectclient.projectview.activity.pending.actions.PAID_EXPENSE_REPORT.action.primary') }}
                </VJoyButton>
            </NuxtLink>
        </template>
    </CardContentPanel>
</template>

<script setup lang="ts">
    import {VJoyButton} from '@maltjoy/core-vue';
    import CardContentPanel from '../CardContentPanel.vue';
    import {useProjectInformationStore} from '@/common/stores';
    import type {ActivityPendingActionByType} from '@/features/project-view';

    defineProps<{
        action: ActivityPendingActionByType<'PAID_EXPENSE_REPORT'>;
        index: number;
    }>();
    const projectInformationStore = useProjectInformationStore();
</script>
